// Exhibitions.js
import React, { useState, useEffect } from 'react';
import './Exhibitions.css';
import e1 from '../Assets/e1.jpeg';
import e2 from '../Assets/e2.jpeg';
import e3 from '../Assets/e3.jpeg';
import e4 from '../Assets/e4.jpeg';

const Exhibitions = ({ language = 'en' }) => {
  const [scrollY, setScrollY] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [modalImage, setModalImage] = useState(null);

  // Translations
  const translations = {
    en: {
      heroTitle: 'Our Exhibitions',
      heroSubtitle: 'Discover our global presence at premium stone industry exhibitions',
      upcomingBadge: 'Upcoming Exhibition',
      upcomingTitle: 'MARMOMAC 2025',
      upcomingSubtitle: 'Join us at the world\'s leading natural stone exhibition',
      eventName: 'Event',
      eventValue: 'MARMOMAC 2025',
      location: 'Location',
      locationValue: 'HALL 11 · STAND A5-A6',
      date: 'Date',
      dateValue: '23 SEPTEMBER 2025',
      city: 'City',
      cityValue: 'Verona, Italy',
      pastExhibitions: 'Past Exhibitions',
      chinaTitle: '2025 China Xiamen Stone Fair',
      chinaDate: 'March 2025',
      chinaDescription: 'PA Global Collab showcased our premium natural quartzite and stone blocks at the prestigious China Xiamen Stone Fair 2025. Our stunning exhibition booth featured our finest stone varieties, attracting visitors from around the world who were impressed by our quality and craftsmanship.',
      highlights: 'Exhibition Highlights',
      highlight1: 'Premium natural quartzite displays showcasing texture and quality',
      highlight2: 'Direct quarry-to-client consultations with industry experts',
      highlight3: 'Interactive stone selection experience for international buyers',
      highlight4: 'Sustainable quarrying practices demonstration and education',
      visitUs: 'Visit Us',
      visitUsDesc: 'Meet our expert team and explore our premium stone collection',
      globalPresence: 'Global Presence',
      globalPresenceDesc: 'Connecting with international partners and clients worldwide'
    },
    zh: {
      heroTitle: '我们的展览',
      heroSubtitle: '在优质石材行业展览中发现我们的全球影响力',
      upcomingBadge: '即将举办的展览',
      upcomingTitle: 'MARMOMAC 2025',
      upcomingSubtitle: '加入我们参加世界领先的天然石材展览',
      eventName: '活动',
      eventValue: 'MARMOMAC 2025',
      location: '位置',
      locationValue: '11号馆 · A5-A6展台',
      date: '日期',
      dateValue: '2025年9月23日',
      city: '城市',
      cityValue: '意大利维罗纳',
      pastExhibitions: '过往展览',
      chinaTitle: '2025中国厦门石材展',
      chinaDate: '2025年3月',
      chinaDescription: 'PA Global Collab在享有盛誉的2025中国厦门石材展上展示了我们优质的天然石英岩和石材块。我们令人惊艳的展览展台展示了我们最优质的石材品种，吸引了来自世界各地的参观者，他们对我们的质量和工艺印象深刻。',
      highlights: '展览亮点',
      highlight1: '优质天然石英岩展示，展现质地和品质',
      highlight2: '与行业专家进行直接的采石场到客户咨询',
      highlight3: '为国际买家提供互动式石材选择体验',
      highlight4: '可持续采石实践演示和教育',
      visitUs: '访问我们',
      visitUsDesc: '与我们的专家团队会面，探索我们的优质石材收藏',
      globalPresence: '全球影响力',
      globalPresenceDesc: '与国际合作伙伴和全球客户建立联系'
    },
    it: {
      heroTitle: 'Le Nostre Esposizioni',
      heroSubtitle: 'Scopri la nostra presenza globale nelle migliori fiere del settore lapideo',
      upcomingBadge: 'Prossima Esposizione',
      upcomingTitle: 'MARMOMAC 2025',
      upcomingSubtitle: 'Unisciti a noi alla principale fiera mondiale della pietra naturale',
      eventName: 'Evento',
      eventValue: 'MARMOMAC 2025',
      location: 'Posizione',
      locationValue: 'PADIGLIONE 11 · STAND A5-A6',
      date: 'Data',
      dateValue: '23 SETTEMBRE 2025',
      city: 'Città',
      cityValue: 'Verona, Italia',
      pastExhibitions: 'Esposizioni Passate',
      chinaTitle: '2025 Fiera della Pietra di Xiamen Cina',
      chinaDate: 'Marzo 2025',
      chinaDescription: 'PA Global Collab ha esposto le nostre quartziti naturali premium e blocchi di pietra alla prestigiosa Fiera della Pietra di Xiamen Cina 2025. Il nostro splendido stand espositivo presentava le nostre migliori varietà di pietra, attirando visitatori da tutto il mondo che sono rimasti impressionati dalla nostra qualità e maestria.',
      highlights: 'Punti Salienti dell\'Esposizione',
      highlight1: 'Esposizioni di quartzite naturale premium che mostrano texture e qualità',
      highlight2: 'Consultazioni dirette dalla cava al cliente con esperti del settore',
      highlight3: 'Esperienza interattiva di selezione della pietra per acquirenti internazionali',
      highlight4: 'Dimostrazione ed educazione delle pratiche di estrazione sostenibile',
      visitUs: 'Visitaci',
      visitUsDesc: 'Incontra il nostro team di esperti ed esplora la nostra collezione di pietre premium',
      globalPresence: 'Presenza Globale',
      globalPresenceDesc: 'Connessioni con partner internazionali e clienti in tutto il mondo'
    }
  };

  const t = translations[language] || translations.en;

  

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setMousePosition({ x, y });
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    // Animation observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect();
    };
  }, []);

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div className="exhibitions-container">
      {/* Hero Section */}
      <section className="exhibitions-hero">
        <div className="hero-background">
          <div 
            className="parallax-layer layer-1" 
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
          <div 
            className="parallax-layer layer-2" 
            style={{ transform: `translateY(${scrollY * 0.2}px)` }}
          />
        </div>
        
        <div className="hero-content">
          <h1 className="hero-title">{t.heroTitle}</h1>
          <p className="hero-subtitle">{t.heroSubtitle}</p>
          
          {/* Animated Icon */}
          <div className="hero-icon">
            <div className="icon-circle">
              <div className="icon-inner">🏛️</div>
              <div className="icon-ring ring-1"></div>
              <div className="icon-ring ring-2"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Exhibition */}
      <section className="upcoming-exhibition">
        <div className="upcoming-container">
          <div className="upcoming-badge">
            {t.upcomingBadge}
          </div>
          
          <h2 className="upcoming-title">
            {t.upcomingTitle}
          </h2>
          
          <div className="upcoming-details">
            <p className="hero-subtitle">{t.upcomingSubtitle}</p>
            
            <div className="exhibition-info">
              <div className="info-item">
                <div className="info-icon">🎪</div>
                <div className="info-label">{t.eventName}</div>
                <div className="info-value">{t.eventValue}</div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">📍</div>
                <div className="info-label">{t.location}</div>
                <div className="info-value">{t.locationValue}</div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">📅</div>
                <div className="info-label">{t.date}</div>
                <div className="info-value">{t.dateValue}</div>
              </div>
              
              <div className="info-item">
                <div className="info-icon">🌍</div>
                <div className="info-label">{t.city}</div>
                <div className="info-value">{t.cityValue}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Past Exhibitions */}
      <section className="past-exhibitions">
        <div className="past-container">
          <h2 className="section-title animate-on-scroll">{t.pastExhibitions}</h2>
          
          <div className="exhibition-card animate-on-scroll">
            <div className="card-header">
              <h3 className="card-title">{t.chinaTitle}</h3>
              <p className="card-date">{t.chinaDate}</p>
            </div>
            
            <div className="card-content">
              <p className="card-description">{t.chinaDescription}</p>
              
              {/* Image Gallery */}
            <div className="image-gallery">
            <div className="gallery-main" onClick={() => openModal(e1)}>
                <img 
                src={e1} 
                alt="PA Global Collab main exhibition booth"
                className="gallery-image"
                />
                <div className="image-overlay">🔍</div>
            </div>
            
            <div className="gallery-item" onClick={() => openModal(e2)}>
                <img 
                src={e2} 
                alt="Stone consultation area"
                className="gallery-image"
                />
                <div className="image-overlay">🔍</div>
            </div>
            
            <div className="gallery-item" onClick={() => openModal(e3)}>
                <img 
                src={e3} 
                alt="Premium stone displays"
                className="gallery-image"
                />
                <div className="image-overlay">🔍</div>
            </div>
            
            <div className="gallery-item" onClick={() => openModal(e4)}>
                <img 
                src={e4} 
                alt="Architectural stone designs"
                className="gallery-image"
                />
                <div className="image-overlay">🔍</div>
            </div>
            </div>
              
              {/* Exhibition Highlights */}
              <div className="exhibition-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">💎</div>
                  <div className="highlight-text">{t.highlight1}</div>
                </div>
                
                <div className="highlight-item">
                  <div className="highlight-icon">🤝</div>
                  <div className="highlight-text">{t.highlight2}</div>
                </div>
                
                <div className="highlight-item">
                  <div className="highlight-icon">🎯</div>
                  <div className="highlight-text">{t.highlight3}</div>
                </div>
                
                <div className="highlight-item">
                  <div className="highlight-icon">🌱</div>
                  <div className="highlight-text">{t.highlight4}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      <div 
        className={`image-modal ${modalImage ? 'active' : ''}`}
        onClick={handleModalClick}
      >
        <div className="modal-content">
          {modalImage && (
            <img 
              src={modalImage} 
              alt="PA Global Collab booth at exhibition" 
              className="modal-image"
            />
          )}
          <button className="modal-close" onClick={closeModal}>
            <svg viewBox="0 0 24 24" width="24" height="24">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
          </button>
        </div>
      </div>

      {/* Floating Background Elements */}
      <div className="background-shapes">
        <div 
          className="shape shape-1"
          style={{ transform: `translate(${mousePosition.x * 25}px, ${mousePosition.y * 25}px)` }}
        />
        <div 
          className="shape shape-2"
          style={{ transform: `translate(${mousePosition.x * -20}px, ${mousePosition.y * -20}px)` }}
        />
        <div 
          className="shape shape-3"
          style={{ transform: `translate(${mousePosition.x * 15}px, ${mousePosition.y * -15}px)` }}
        />
      </div>
    </div>
  );
};

export default Exhibitions;